<template>
    <section class="tables new-updated-design px-0 px-md-0 pt-4 pt-md-0">
        <vue-snotify></vue-snotify>
        <div>
            <b-modal id="invoice-modal" ref="invoice-modal" scrollable :title="$t('Propertis.Invoice_Details')"
                size="xl" :hide-footer="true">
                <div class="invoice-table" v-if="selectedInvoice">
                    <div class="top-content d-flex align-items-center justify-content-between gap-2">
                        <div class="header-logo">
                            <img src="../public/assets/images/Vanovy-Logo.svg" alt="logo">
                        </div>
                    </div>
                    <div class="body-content">
                        <div class="body-head">
                            <h3 class="title">{{ $t('Propertis.Customer_Information') }}</h3>
                            <div class="row">
                                <div class="col-lg-4 col-md-6">
                                    <div class="form-group">
                                        <label for="">{{ $t('register.name') }}:</label> <span>{{
                                            selectedInvoice['first_name' +
                                            currentLanguage] }} {{ selectedInvoice['last_name' + currentLanguage]
                                            }}</span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <div class="form-group">
                                        <label for="">{{ $t('login.email') }}:</label> <span>{{ selectedInvoice['email'
                                            + currentLanguage]
                                            }}</span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <div class="form-group">
                                        <label for="">{{ $t('register.phone') }}:</label> <span>{{
                                            selectedInvoice['phone_number' +
                                            currentLanguage] }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="body-table-content">
                            <div class="responsive-table">
                                <h3 class="title">{{ $t('Propertis.Reservation_Details') }}</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{{ $t('Propertis.Title') }}</th>
                                            <th>{{ $t('Propertis.Description') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ $t('Propertis.Accommodation_Name') }}:</td>
                                            <td>{{ selectedInvoice.property.property_type }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Property_Address') }}:</td>
                                            <td>{{ selectedInvoice.property.address }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Check_in') }}:</td>
                                            <td>{{ formatDate(selectedInvoice.start_date) }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Check_out') }}:</td>
                                            <td>{{ formatDate(selectedInvoice.end_date) }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Length_of_Stay') }}:</td>
                                            <td>{{ selectedInvoice.number_of_nights }} {{ $t('Propertis.nights') }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Accommodation_Type_Reserved') }}:</td>
                                            <td>{{ selectedInvoice.property.accommodation_type }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.number_of_guests') }}:</td>
                                            <td>{{ selectedInvoice.number_of_guests }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="responsive-table financial-table">
                                <h3 class="title">{{ $t('Propertis.Financial_Details') }}</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{{ $t('Propertis.Title') }}</th>
                                            <th>{{ $t('Propertis.Description') }}</th>
                                            <th>{{ $t('booking.Amount') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ $t('booking.total_price') }}:</td>
                                            <td>{{ $t('Propertis.Total_Reservation_Description') }}
                                            </td>
                                            <td>{{ selectedInvoice.payment_currency }} {{ selectedInvoice.total_price }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Currency') }}:</td>
                                            <td>{{ selectedInvoice.payment_currency }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('invoice.payment_policy') }}:</td>
                                            <td>{{ $t('Propertis.Payment_Policy_Description') }}</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('invoice.cancellation_refund_policy') }}:</td>
                                            <td colspan="2">
                                                {{ $t('Propertis.Cancellation_Description') }}.
                                                <a href="/cancellation-and-refund-policy" target="_blank">
                                                    {{ $t('invoice.view_cancellation_policy') }}
                                                </a>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('payment.discounted_amount') }}:</td>
                                            <td></td>
                                            <td>{{ selectedInvoice.payment_currency }} {{
                                                selectedInvoice.discount_amount }}</td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('discounts.discount_percentage') }}:</td>
                                            <td></td>
                                            <td>{{ selectedInvoice.discount_percentage }}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="responsive-table">
                                <h3 class="title">{{ $t('Propertis.Other_Details') }}</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>{{ $t('Propertis.Title') }}</th>
                                            <th>{{ $t('Propertis.Description') }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ $t('property_detail.Property_Policies') }}:</td>
                                            <td v-html="selectedInvoicePolicies"></td>
                                        </tr>
                                        <tr>
                                            <td>{{ $t('Propertis.Included_Services') }}:</td>
                                            <td>{{ selectedInvoiceServices }}</td>
                                        </tr>
                                        <tr v-if="selectedInvoice.email || selectedInvoice.mobile_phone">
                                            <td>{{ $t('Propertis.Property_Contact_Information') }}:</td>
                                            <td>
                                                <template v-if="selectedInvoice.email && selectedInvoice.mobile_phone">
                                                    {{ selectedInvoice.email }} <b>{{ $t('common.and') }}</b> {{
                                                        selectedInvoice.mobile_phone
                                                    }} {{
                                                        $t('common.for_inquiries') }}
                                                </template>
                                                <template v-else-if="selectedInvoice.email">
                                                    {{ selectedInvoice.email }} {{ $t('common.for_inquiries') }}
                                                </template>
                                                <template v-else-if="selectedInvoice.mobile_phone">
                                                    {{ selectedInvoice.mobile_phone }} {{ $t('common.for_inquiries') }}
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="price-list">
                            <h3 class="amount">{{ $t('booking.total_price') }}: <span class="price">{{
                                selectedInvoice.payment_currency }}
                                    {{ selectedInvoice.total_price }}</span></h3>
                        </div>
                    </div>
                    <div class="footer-content">
                        <p class="text-center"> <span>support@vanovy.com</span><span>
                                www.vanovy.com</span></p>
                    </div>
                </div>
            </b-modal>
        </div>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card properties-table">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">{{ $t('properties_list.view_invoices') }}</h4>
                    </div>
                    <div class="card-body">
                        <div class="search-bar mb-3 search-bar-style">
                            <b>{{ $t('common.search') }}: </b>
                            <input style="border: 1px solid #dcdfe6;" type="text" v-model="serverParams.search"
                                @input="onSearch" :placeholder="$t('common.search_placeholder')" />
                        </div>
                        <vue-good-table mode="remote" @on-page-change="onPageChange"
                            @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :pagination-options="{
                                enabled: true, dropdownAllowAll: false, perPageDropdown: [10, 20, 50, 100, 200], nextLabel: this.$t('pagination.next'),
                                prevLabel: this.$t('pagination.Previous'),
                                rowsPerPageLabel: this.$t('pagination.rowsPerPage'),
                                ofLabel: this.$t('pagination.of'),
                            }" :rows="rows" :columns="columns" :sort-options="{
                                enabled: false,
                            }">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'first_name'">
                                    <span>{{ props.row['first_name' + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'last_name'">
                                    <span>{{ props.row['last_name' + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'email'">
                                    <span>{{ props.row['email' + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'phone_number'">
                                    <span>{{ props.row['phone_number' + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'card_holder'">
                                    <span>{{ props.row['card_holder' + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'start_date'">
                                    <span>{{ formatDate(props.row["start_date" + currentLanguage]) }}</span>
                                </span>
                                <span v-if="props.column.field == 'end_date'">
                                    <span>{{ formatDate(props.row["end_date" + currentLanguage]) }}</span>
                                </span>
                                <span v-if="props.column.field == 'commission'">
                                    <span>{{ props.row["payment_currency" + currentLanguage] }} {{
                                        props.row["commission" + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'total_price'">
                                    <span>{{ props.row["payment_currency" + currentLanguage] }} {{
                                        props.row["total_price" + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field === 'action'" class="text-nowrap properties-btns">
                                    <b-button @click="viewInvoiceDetails(props.row)" class="mr-1 edit-btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="17"
                                            height="17" fill="white">
                                            <path
                                                d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
                                        </svg>

                                    </b-button>
                                    <b-button @click="downloadInvoice(props.row)" class="mr-1 edit-btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17"
                                            viewBox="0 0 24 24" fill="white">
                                            <g id="Interface / Download">
                                                <path id="Vector" d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12"
                                                    stroke="white" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </g>
                                        </svg>
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue, { set } from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api';
import moment from 'moment';
import axios from 'axios';

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            searchTime: null,
            isDisabled: false,
            modalContent: '',
            selectedInvoice: null,
            currentLanguage: '',
            selected: true,
            unSelected: false,
            serverParams: {
                search: "",
                sort: [
                    {
                        field: 'UserID',
                        type: 'desc'
                    }
                ],
                page: 1,
                perPage: 10
            },
            columns: [
                {
                    label: this.$t('register.first_name'),
                    field: 'first_name',
                    filterable: false,
                },
                {
                    label: this.$t('register.last_name'),
                    field: 'last_name',
                    filterable: false,
                },
                {
                    label: this.$t('login.email'),
                    field: 'email',
                    filterable: false,
                },
                {
                    label: this.$t('register.phone'),
                    field: 'phone_number',
                    filterable: false,
                },
                {
                    label: this.$t('payment.card_holder_name'),
                    field: 'card_holder',
                    filterable: false,
                },
                {
                    label: this.$t('Propertis.start_date'),
                    field: 'start_date',
                    filterable: false,
                },
                {
                    label: this.$t('Propertis.end_date'),
                    field: 'end_date',
                    sortable: false,
                },
                {
                    label: this.$t('payment.commission'),
                    field: 'commission',
                    sortable: false,
                },
                {
                    label: this.$t('booking.total_price'),
                    field: "total_price",
                    sortable: false,
                },
                {
                    label: this.$t('properties_list.action'),
                    field: "action",
                    sortable: false,
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: [],
            ReferredBy: new Map(),
            form: {
                ReferredID: '',
            },
        };
    },
    methods: {
        formatTime(time) {
            const [hours, minutes] = time.split(':'); // Split the time into hours and minutes
            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);

            let hour = date.getHours();
            const minute = date.getMinutes();
            const period = hour >= 12 ? 'PM' : 'AM';

            hour = hour % 12 || 12; // Convert 24-hour time to 12-hour time
            const formattedTime = `${hour}:${minute < 10 ? '0' + minute : minute} ${period}`;

            return formattedTime;
        },
        formatDate(date) {
            return moment(date).format('DD-MM-YYYY');
        },
        updateColumnLabels() {
            this.columns.forEach(col => {
                switch (col.field) {
                    case 'property_id':
                        col.label = this.$t('Propertis.property_id');
                        break;
                    case 'card_holder':
                        col.label = this.$t('Propertis.card_holder');
                        break;
                    case 'payment_id':
                        col.label = this.$t('Propertis.payment_id');
                        break;
                    case 'pdf_path':
                        col.label = this.$t('Propertis.pdf_path');
                        break;
                    case 'action':
                        col.label = this.$t('properties_list.action');
                        break;
                    default:
                        break;
                }
            });
        },
        onLanguageChanged(language) {
            if (language == 'en') {
                this.currentLanguage = '';
            } else {
                this.currentLanguage = '_' + language;
            }

        },
        onSearch() {
            clearTimeout(this.searchTime); // Clear any existing timeout
            this.searchTime = setTimeout(() => { // Set a new timeout
                this.updateParams({ page: 1 }); // Reset to page 1 when searching
                this.loadItems();
            }, 500);
        },
        viewInvoiceDetails(invoice) {
            this.selectedInvoice = invoice;
            this.$refs['invoice-modal'].show();
        },
        editProperty(property) {
            this.$router.push({ name: 'property_id', params: { id: property.id, data: property } });
        },
        downloadInvoice(row) {
            const pdfUrl = row.pdf_path;
            if (pdfUrl) {
                window.open(pdfUrl, '_blank');
            } else {
                console.error('Invoice URL not found.');
            }
        },
        propertyRating(id) {
            this.$router.push({ name: 'view_rating', params: { id: id } });
        },
        dateFormat(val) {
            return moment(val).format('DD MMMM YYYY')
        },
        loadItems() {
            this.isLoading = true;
            API.getInvoices(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data;
                    this.isLoading = false;
                }, err => {
                    console.log(err)
                    this.isLoading = false;
                })
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            console.log("update param", this.serverParams);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
        }
    },
    computed: {
        propertytype() {
            return this.$t('properties_list.Property_Type');
        },
        action() {
            return this.$t('properties_list.action');
        },
        city() {
            return this.$t('properties_list.city');
        },
        state() {
            return this.$t('properties_list.state');
        },
        selectedInvoiceServices() {
            const property = this.selectedInvoice.property;
            const services = [];

            if (property.wifi_available == 1) services.push(this.$t('Propertis.Wifi'));
            if (property.tv_available == 1) services.push(this.$t('Propertis.TV'));
            if (property.kitchen_available == 1) services.push(this.$t('Propertis.Kitchen'));

            return services.length ? services.join(', ') : this.$t('common.none');
        },

        selectedInvoicePolicies() {
            const property = this.selectedInvoice.property;
            const categories = [
                { key: 'Children', label: 'children_are', value: property.children },
                { key: 'Events', label: 'events_are', value: property.Events },
                { key: 'Pets', label: 'pets_are', value: property.Pets },
                { key: 'Smoking', label: 'smoking_is', value: property.Smoking },
            ];

            const normalizeKey = (str) => {
                if (str === undefined || str === null) return 'Not_Allowed';
                if (str === '1' || str === 1) return 'Allowed';
                if (str === '0' || str === 0) return 'Not_Allowed';
                return str
                    .trim()
                    .replace(/\s+/g, '_')
                    .replace(/[^a-zA-Z0-9:_-]/g, '')
                    .replace(/Allowd/, 'Allowed');
            };

            const policies = categories.map(cat => {
                const rawValue = cat.value || 'Not_Allowed';
                const normalizedKey = normalizeKey(rawValue);
                const translationKey = `Propertis.Policies.${cat.key}.${normalizedKey}`;

                const hasTranslation = this.$te(translationKey);
                const translatedValue = hasTranslation
                    ? this.$t(translationKey)
                    : this.$t('common.not_allowed');

                return this.$t(`Propertis.${cat.label}`, {
                    [cat.key.toLowerCase()]: translatedValue,
                });
            });

            return policies.length ? policies.join('<br>') : this.$t('invoice.no_policies');
        }

    },
    mounted() {
        this.isLoading = true;
        Vue.prototype.$EventBus.$on('changeLanguage', this.updateColumnLabels);
        this.loadItems();
        this.updateColumnLabels();
    },
    watch: {
        '$i18n.locale': function (newLocale, oldLocale) {
            this.columns.find(col => col.field === 'property_type').label = this.propertytype;
            this.columns.find(col => col.field === 'action').label = this.action;
            this.columns.find(col => col.field === 'city').label = this.city;
            this.columns.find(col => col.field === 'state').label = this.state;
        }
    }
}
</script>
<style>
#invoice-modal .modal-body {
    padding: 0px;
}

#invoice-modal .modal-header {
    padding: 16px 25px 16px 16px;
    align-items: center;
}

#invoice-modal .modal-header .modal-title {
    font-size: 16px;
}

#invoice-modal .modal-header button.close {
    font-size: 16px;
}

#invoice-modal .modal-body::-webkit-scrollbar {
    width: 6px;
}

/* Track */
#invoice-modal .modal-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

/* Handle */
#invoice-modal .modal-body::-webkit-scrollbar-thumb {
    background: #70D3FF;
    border-radius: 10px;
}

/* Handle on hover */
#invoice-modal .modal-body::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.invoice-table .top-content .header-logo img {
    width: auto;
    height: auto;
    max-width: 300px;
}

.invoice-table td,
.invoice-table th {
    padding: 12px;
}

.invoice-table .top-content {
    padding: 20px 20px 0;
}

.invoice-table .top-content .invoice-btn {
    background-color: #70D3FF;
    border: 1px solid #70D3FF;
    border-radius: 6px !important;
    outline: none;
    box-shadow: none;
    padding: 10px 25px !important;
}

.invoice-table .top-content .invoice-btn:hover {
    background-color: #55cbff;
}

.invoice-table .top-content .invoice-btn span {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
    text-transform: uppercase;
    color: #fff;
}

.invoice-table .body-content {
    padding: 20px;
}

.body-content .body-head {
    margin-bottom: 30px;
    padding-bottom: 10px;
    border-bottom: 1px solid #B6B6B6;
}

.body-content .body-head h3.title {
    font-size: 18px;
    line-height: 1.2;
    font-weight: 500;
    color: #000;
    margin-bottom: 16px;
}

.body-content h3.title {
    font-size: 18px;
    line-height: 1.2;
    font-weight: 500;
    color: #000;
    margin-bottom: 16px;
}

.body-content .body-head .row .col-lg-4:first-child {
    text-align: left;
}

.body-content .body-head .row .col-lg-4:nth-child(2) {
    text-align: center;
}

.body-content .body-head .row .col-lg-4:last-child {
    text-align: right;
}

.body-content .body-head .row .form-group {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.body-content .body-head .row .form-group label {
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    color: #70D3FF;
    margin-right: 5px;
}

.body-content .body-head .row .form-group span {
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    color: #000;
}

.body-content .responsive-table {
    margin-bottom: 30px;
}

.body-content .responsive-table table thead {
    background-color: #70D3FF;
    color: #fff;
}

.body-content .responsive-table.financial-table table thead tr th:nth-child(1) {
    width: 30%;
}

.body-content .responsive-table.financial-table table thead tr th:nth-child(2) {
    width: 60%;
}

.body-content .responsive-table.financial-table table thead tr th:nth-child(3) {
    width: 10%;
    text-align: center;
    min-width: 160px;
}

.body-content .responsive-table.financial-table table tbody tr td:nth-child(3) {
    text-align: center;
    color: #70D3FF;
    font-weight: 600;
}

.body-content .responsive-table table thead tr th:nth-child(1) {
    width: 30%;
}

.body-content .responsive-table table thead tr th:nth-child(2) {
    width: 70%;
}

.body-content .responsive-table table thead tr th {
    font-size: 16px;
    font-weight: bold;
    line-height: normal;
    color: #fff;
}

.body-content .responsive-table table tbody tr td {
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    color: #717171;
}

.body-content .price-list h3.amount {
    text-align: right;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
    color: #000;
    margin-bottom: 0px;
}

.body-content .price-list h3.amount span {
    text-align: right;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
    color: #70D3FF;
    margin-bottom: 0px;
}

.body-content p.description {
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    color: #717171;
    margin-bottom: 0px;
}

.footer-content {
    padding: 20px;
    background-color: #F2FAFD;
    text-align: center;
}

.footer-content p {
    font-size: 16px;
    font-weight: 400;
    line-height: normal;
    color: #717171;
    margin-bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.footer-content p span {
    white-space: nowrap;
    padding: 0 5px;
}

.footer-content p span:not(:last-child) {
    border-right: 2px solid #717171;
}

.body-content .responsive-table table tbody tr td:first-child {
    width: 290px;
    max-width: 290px;
    white-space: break-spaces;
}

@media (max-width: 1200px) {
    #invoice-modal .modal-dialog.modal-lg {
        max-width: 90%;
    }

    .invoice-table .top-content {
        flex-wrap: wrap;
        gap: 16px;
    }
}

@media (max-width: 1023px) {
    #invoice-modal .modal-dialog.modal-lg {
        max-width: 95%;
    }

    .invoice-table .top-content {
        flex-wrap: wrap;
    }
}

@media (max-width: 992px) {
    .body-content .body-head .row .col-lg-4:last-child {
        text-align: left;
    }

    .footer-content p,
    .body-content .body-head .row .form-group span,
    .body-content .body-head .row .form-group label,
    .body-content .responsive-table table tbody tr td,
    .body-content .responsive-table table thead tr th,
    .body-content .price-list h3.amount,
    .body-content .price-list h3.amount span {
        font-size: 14px;
    }

    .invoice-table .top-content .header-logo img {
        max-width: 200px;
    }
}

@media (max-width: 767.5px) {
    .body-content .body-head .row .col-lg-4:nth-child(2) {
        text-align: left;
    }

    .body-content .body-head .row .form-group {
        flex-wrap: nowrap;
    }

    .body-content .body-head .row .form-group label {
        min-width: 150px;
    }
}

@media (max-width: 550px) {
    .invoice-table .top-content .invoice-btn {
        padding: 6px 16px !important;
    }

    .body-content .body-head .row .form-group label {
        min-width: 100px;
    }

    .footer-content p span:not(:last-child) {
        border-right: 1px solid #717171;
    }
}

@media (max-width: 400px) {
    .body-content .body-head .row .form-group {
        flex-direction: column;
        align-items: flex-start;
    }
}

.modal-open .modal {
    margin-right: 0px !important;
}
</style>